<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h1 class="title">Balance history</h1></app-cells>
      <app-cells><h2 class="title">Aishi Machame Hotel</h2></app-cells>
      <v-client-table
        :data="table_aishi.items"
        :columns="table_aishi.columns"
        :options="table_aishi.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_aishi }"
      >
        <template #h__created_by><div class="table-default__left">Created by</div></template>
        <template #h__period><div class="table-default__left">Period</div></template>
        <template #created_by="{ row }">
          <div v-if="row.created_by" class="table-default__left table-default__controls">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.created_by.crop.crop_url)" alt="Avatar">
            </div>
            {{ row.created_by.full_name }}
          </div>
        </template>
        <template #period="{ row }">
          <router-link :to="{name: 'hotel-management-balance-history-detail', params: {id: row.id }}"
                       class="table-default__link-border">
            {{ formatDateTime(row.start_time) }} - {{ formatDateTime(row.created_at) }}
          </router-link>
        </template>
        <template #balance="{ row }">
          <img v-if="row.balance" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
        <template #pos="{ row }">
          <img v-if="row.pos" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
        <template #cashflow="{ row }">
          <img v-if="row.cashflow" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
      </v-client-table>
      <app-cells position="between">
        <paginate
          :clickHandler="onClickPaginationAishi"
          v-if="pagination_aishi.pages > 1"
          v-model="pagination_aishi.page"
          :page-count="pagination_aishi.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
        <app-table-records :all="pagination_aishi.count" :count="table_aishi.items.length" :page="pagination_aishi.page" :limit="10" />
      </app-cells>
      <app-cells><h2 class="title">BruBru Lodge</h2></app-cells>
      <v-client-table
        :data="table_bru.items"
        :columns="table_bru.columns"
        :options="table_bru.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_bru }"
      >
        <template #h__created_by><div class="table-default__left">Created by</div></template>
        <template #h__period><div class="table-default__left">Period</div></template>
        <template #created_by="{ row }">
          <div v-if="row.created_by" class="table-default__left table-default__controls">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.created_by.crop.crop_url)" alt="Avatar">
            </div>
            {{ row.created_by.full_name }}
          </div>
        </template>
        <template #period="{ row }">
          <router-link :to="{name: 'hotel-management-balance-history-detail', params: {id: row.id }}"
                       class="table-default__link-border">
            {{ formatDateTime(row.start_time) }} - {{ formatDateTime(row.created_at) }}
          </router-link>
        </template>
        <template #balance="{ row }">
          <img v-if="row.balance" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
        <template #pos="{ row }">
          <img v-if="row.pos" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
        <template #cashflow="{ row }">
          <img v-if="row.cashflow" src="@/assets/img/check-green-icon.svg" alt="">
          <img v-else src="@/assets/img/not-check-red-icon.svg" alt="">
        </template>
      </v-client-table>
      <app-cells position="between">
        <paginate
          :clickHandler="onClickPaginationBru"
          v-if="pagination_bru.pages > 1"
          v-model="pagination_bru.page"
          :page-count="pagination_bru.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
        <app-table-records :all="pagination_bru.count" :count="table_bru.items.length" :page="pagination_bru.page" :limit="10" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementBalanceHistoryList } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'HotelManagementBalanceHistoryList',
  data() {
    return {
      page_loaded: false,
      table_aishi: {
        items: [],
        columns: ['created_by', 'period', 'balance', 'pos', 'cashflow'],
        options: {
          headings: {
            created_by: 'Created by',
            period: 'Period',
            balance: 'Balance',
            pos: 'POS',
            cashflow: 'Cashflow',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_aishi: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_aishi: false,
      table_bru: {
        items: [],
        columns: ['created_by', 'period', 'balance', 'pos', 'cashflow'],
        options: {
          headings: {
            created_by: 'Created by',
            period: 'Period',
            balance: 'Balance',
            pos: 'POS',
            cashflow: 'Cashflow',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bru: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_bru: false,
    }
  },
  created() {
    Promise.all([this.fetchItemsAishi(), this.fetchItemsBru()])
      .then(() => {
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsAishi() {
      this.table_preloader_aishi = true
      const response = await getHotelManagementBalanceHistoryList({page: this.pagination_aishi.page, page_size: 10, property: 'aishi'})
      this.table_aishi.items = response.data.results
      this.pagination_aishi.pages = response.data.pages
      this.pagination_aishi.count = response.data.count
      this.table_preloader_aishi = false
    },
    async fetchItemsBru() {
      this.table_preloader_bru = true
      const response = await getHotelManagementBalanceHistoryList({page: this.pagination_aishi.page, page_size: 10, property: 'brubru'})
      this.table_bru.items = response.data.results
      this.pagination_bru.pages = response.data.pages
      this.pagination_bru.count = response.data.count
      this.table_preloader_bru = false
    },
    onClickPaginationAishi(page) {
      this.pagination_aishi.page = page
      this.fetchItemsAishi()
    },
    onClickPaginationBru(page) {
      this.pagination_bru.page = page
      this.fetchItemsBru()
    },
    formatDateTime(date) {
      return date ? format(parseISO(date), 'dd MMMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
